import { Box, Grid } from '@mui/material';

import { formatCurrency, getCurrencyIcon } from '../../../lib/currencyUtils';
import { Currency } from '../../../lib/enum';
import MetricCard from './MetricCard';

interface MetricsGridProps {
  totalUsersAttracted: number;
  lifetimeEarnings: number;
  currency?: string;
  balance?: number;
}

const MetricsGrid = ({ 
  totalUsersAttracted, 
  lifetimeEarnings, 
  currency, 
  balance
}: MetricsGridProps) => {
  const formatEarnings = (amount: number) => {
    if (currency) {
      try {
        return formatCurrency(amount, currency as Currency);
      } catch {
        return `${amount} ${currency}`;
      }
    }
    return amount.toString();
  };

  const renderEarningsWithIcon = (amount: number) => {
    if (!currency || amount === 0) return amount.toString();

    const formattedAmount = formatEarnings(amount);
    const currencyIcon = getCurrencyIcon(currency as Currency, 'large');

    if (currencyIcon && currency === Currency.SAR) {
      const IconComponent = currencyIcon;
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <IconComponent color="white" />
          <span>{formattedAmount.replace('SAR', '').trim()}</span>
        </Box>
      );
    }

    return formattedAmount;
  };


  return (
    <Grid container spacing={2} sx={{ width: '100%' }}>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        <MetricCard
          title="Referred Customers"
          value={totalUsersAttracted || 0}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        <MetricCard
          title="Lifetime Earnings"
          value={renderEarningsWithIcon(lifetimeEarnings || 0)}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        <MetricCard
          title="Available to Withdraw"
          value={renderEarningsWithIcon(balance || 0)}
        />
      </Grid>
    </Grid>
  );
};

export default MetricsGrid; 